import React, { Component } from 'react';
import { Row, Field, Label, Button, ButtonLink, TextInput, RadioInput, Checkmark, TextArea }  from '../../generic';
import styled from 'styled-components';
import { validRadio } from '../../../helpers/check-required-fields';
import SocialSharing from '../SocialSharing'
import * as variables from '../../../styles/variables'

const ButtonExternal = Button.withComponent('a')
const ButtonDiv = Button.withComponent('div')

const HorizontalDivider = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin: -20px 0 20px;
  @media screen and (min-width: 600px) {
    margin: 30px 0;
  }
`

const SocialMedia = styled.a`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin: 0 15px 10px 0;
  color: #666;
  text-decoration: none;
  &:before {
    display: block;
    content: '';
    width: 35px;
    height: 35px;
    background: red;
    margin-bottom: 5px;
  }
`

const Success = styled.div`
  display: block;
  background: rgba(161, 220, 237, 0.16);
  border: 3px solid ${variables.colours.lightBlue};
  border-radius: 10px;
  padding: 11px 15px 15px;
  margin: 10px 0px 15px;
`

const ButtonWrap = styled.div`
  > * {
    margin: 0;
    display: block;
    width: 100%;
    max-width: 300px;
    @media screen and (min-width: 600px) {
      width: auto;
      display: inline-block;
    }
  }
  > *:first-of-type {
    margin-bottom: 10px;
    @media screen and (min-width: 600px) {
      margin-bottom: 0px;
    }
  }
`

class RSVPOptions extends Component {
  render() {
    const { userEvent, onChange, onSubmit, guest, valid, loading, sent } = this.props

    return (
      <React.Fragment>
        <HorizontalDivider/>
        <h2>Can You Attend? RSVP Here</h2>

        {validRadio(userEvent.external_rsvp, false) && !sent && (
          <form onSubmit={onSubmit} style={(validRadio(guest.status, 'yes') || validRadio(guest.status, 'no')) ? {margin: '25px 0px 50px'} : {margin: '25px 0px 15px'}}>
            <Field name="guest[status]" error={false} required={true}>
              <ButtonWrap>
                <ButtonDiv style={{padding: '10px 20px 0', marginRight: '20px'}} type="button"><RadioInput disabled={loading} name="guest[status]" onChange={onChange} checked={validRadio(guest.status, 'yes')} value={'yes'} label="Yes, I’ll Attend" /></ButtonDiv>
                <ButtonDiv style={{padding: '10px 20px 0'}} type="button"><RadioInput disabled={loading} name="guest[status]" onChange={onChange} checked={validRadio(guest.status, 'no')} value={'no'} label="No, I’m Unable to Attend"/></ButtonDiv>
              </ButtonWrap>
            </Field>
            {(validRadio(guest.status, 'yes') || validRadio(guest.status, 'no')) && (
              <React.Fragment>
                <Row className="twoCol">
                  <Field name="guest[first_name]">
                    <Label value="First Name" required={true} />
                    <TextInput disabled={loading} value={guest.first_name} onChange={onChange} />
                  </Field>
                  <Field name="guest[last_name]">
                    <Label value="Last Name" required={true} />
                    <TextInput disabled={loading} value={guest.last_name} onChange={onChange} />
                  </Field>
                  <Field name="guest[email]">
                    <Label value="Email" required={true} />
                    <TextInput disabled={loading} value={guest.email} onChange={onChange} />
                  </Field>
                </Row>
                <Field name="guest[message]" error={false}>
                  <Label value="Message"/>
                  <TextArea disabled={loading} value={guest.message} onChange={onChange} rows={5} />
                </Field>
                <Button type="submit" disabled={!valid || loading}>Send My RSVP</Button>
              </React.Fragment>
            )}
          </form>
        )}

        {sent && (
          <Success>
            <Checkmark /> Thanks for your RSVP! Email your host if you need to make a change.
          </Success>
        )}

        <p>Your email address will only be used for On the Table. <a href={process.env.REACT_APP_BASE_URL + "/legal"}>Visit our privacy policy</a> for more information.</p>

        {validRadio(userEvent.public_access, true) ? (
          <React.Fragment>
            <p><strong>This is a public event. Please share this page with your friends and on social media.</strong></p>
            <SocialSharing event={userEvent} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <p><strong>This is a private event. Please do not share this web page without asking the host in advance.</strong></p>
          </React.Fragment>
        )}
        <p style={{marginTop: "16px"}}>To learn more about On the Table BC, visit <a href={process.env.REACT_APP_BASE_URL}>onthetablebc.com</a>.</p>

        {validRadio(userEvent.external_rsvp, true) && (
          <ButtonExternal href={userEvent.registration_url}>Register to Attend</ButtonExternal>
        )}

      </React.Fragment>
    )
  }
}

export default RSVPOptions
